import { render, staticRenderFns } from "./editrole.vue?vue&type=template&id=f6da4ba4&"
import script from "./editrole.vue?vue&type=script&lang=js&"
export * from "./editrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports